import React from 'react';

import { flagStyles } from '../settings';

const SvgIE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2400px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgIE;
